/* eslint-disable camelcase */
import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { JobContext } from 'context/jobContextContainer';

// Alert that surfaces open Smart Match flags and opens the modal. Rendered
// inside JobTableSection's BannerStack, which handles positioning and spacing.
const SmartMatchBanner = () => {
  const { smartMatchSuggestions, setSmartMatchModalInfo } = useContext(JobContext);
  // Client-side snooze: hide a job's banner until page refresh (still reachable via its row pill).
  const [hiddenIds, setHiddenIds] = useState([]);

  const list = (Array.isArray(smartMatchSuggestions) ? smartMatchSuggestions : []).filter(
    s => !hiddenIds.includes(s.job_id)
  );

  if (list.length === 0) {
    return null;
  }

  // API returns late-first, then by pickup time; lead with the highest-priority flag.
  const lead = list[0];
  const isLate = lead.trigger_type === 'late';
  const passenger = [lead.passenger_fname, lead.passenger_lname].filter(Boolean).join(' ');
  const extra = list.length - 1;

  return (
    <Banner className={isLate ? 'late' : 'due'}>
      <div className="sm-banner-body">
        <div className="sm-banner-eyebrow">{isLate ? 'TRIP RUNNING LATE' : 'RESERVATION DUE'}</div>
        <div className="sm-banner-title">
          {isLate
            ? `Job #${lead.job_id}${passenger ? ` — ${passenger}` : ''} may miss pickup`
            : 'A booked trip is ready for dispatch'}
        </div>
        {extra > 0 ? <div className="sm-banner-more">+{extra} more waiting</div> : null}
      </div>
      <Button variant="contained" onClick={() => setSmartMatchModalInfo(lead)} className="sm-banner-btn">
        Review &amp; Dispatch
      </Button>
      <IconButton
        size="small"
        aria-label="dismiss"
        onClick={() => setHiddenIds([...hiddenIds, lead.job_id])}
        style={{ color: '#8aa0b6' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Banner>
  );
};

export default SmartMatchBanner;

const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 420px;
  max-width: 100%;
  padding: 14px 16px 14px 20px;
  border-radius: 12px;
  background: #0d1b2a;
  color: #e8eef5;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35);
  border-left: 5px solid #2f6df6;

  &.late {
    border-left-color: #ff8a3d;
  }

  .sm-banner-eyebrow {
    font-size: 11px;
    letter-spacing: 1.5px;
    font-weight: 700;
    color: #5f9bff;
  }
  &.late .sm-banner-eyebrow {
    color: #ff8a3d;
  }
  .sm-banner-title {
    font-size: 17px;
    font-weight: 700;
    margin-top: 2px;
  }
  .sm-banner-more {
    font-size: 12px;
    color: #8aa0b6;
    margin-top: 2px;
  }
  .sm-banner-body {
    flex: 1;
  }
  .sm-banner-btn {
    background: #2f6df6;
    color: #fff;
    white-space: nowrap;
  }
`;
